export default __webpack_public_path__ + "static/media/Behance Icon.5634209a.svg";